Namespace 'Monitoring.Models.SocialContents.GoogleMyBusiness.Builders'

class Monitoring.Models.SocialContents.GoogleMyBusiness.Builders.GoogleMyBusinessAuthorBuilder
  setName: (name) =>
    @name = name

  getName: =>
    @name

  setProfilePhotoUrl: (profilePhotoUrl) =>
    @profilePhotoUrl = profilePhotoUrl

  getProfilePhotoUrl: =>
    @profilePhotoUrl

  build: =>
    new Monitoring.Models.SocialContents.GoogleMyBusiness.GoogleMyBusinessAuthor(@)
